import { supabase } from '@fd/supabase/index';
import useSWR from 'swr';

export default function useOrder() {
  const { data } = useSWR('order', async () => {
    return (
      await supabase
        .from('customer_order')
        .select()
        .eq('is_paid', true)
        .order('created_at', { ascending: false })
    ).data;
  });
  return data || [];
}
